import { useContext, useEffect, useState } from "react";
import trans, { isRTL } from "../../../utils";
import { exportContext } from "../../../context/ExportDataContext";
import { useLazyGetSummaryReportsQuery } from "../../../Redux/service/NewReports/Reports";
import { useLazyGetDistanceReportQuery } from "../../../Redux/service/Summary/Summary";
import { filtrationcontext } from "../../../context/Filtercontext";
import AntdTable from "../../antd/Table/Table";
import { DistanceUnit } from "../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";
import { useReportTableColumns } from "../ReportColumns/reportColumns";

const DistanceSheetTable = ({
  selectedids,
  startDate,
  endDate,
  isShown,
  currentPage,
  setCurrentPage,
  setTotalData,
  sumIds,
}) => {
  const { setFileName, setExportIds, setStartDateE, setEndDateE } =
    useContext(exportContext);
  const {
    Sort,
    setSort: SetSortFilter,
    searchQuery,
    setSearchQuery,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const inf = useSelector((state) => state.users.user);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  const [trigger, { data }] = useLazyGetSummaryReportsQuery();
  const [SumTrigger, { data: sumData }] = useLazyGetDistanceReportQuery();
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: trans("Vehicle"),
      dataIndex: "deviceName",
      width: 150,
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
      render: (deviceName) => (
        <span className={"table-element-name ps-0"}>{deviceName}</span>
      ),
    },
    {
      title: trans("Group"),
      dataIndex: "groupName",
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
      width: 150,
      render: (groupName) => groupName || trans("Ungrouped Vehicles"),
    },
    {
      title: trans("Date"),
      key: "date",
      dataIndex: "endTime",
      width: 180,
      sorter: true,
      render: (endTime) => {
        const date = new Date(endTime);
        return (
          <span className="table-element-date">
            {date.toLocaleDateString()} {date.toLocaleTimeString()}
          </span>
        );
      },
    },
    {
      title: trans("Distance"),
      dataIndex: "distance",
      width: 120,
      sorter: true,
      render: (value) => DistanceUnit(value,inf?.attributes?.distanceUnit || "km"),
    },
    {
      title: trans("Odometer Start"),
      dataIndex: "startOdometer",
      sorter: true,
      width: 150,
      render: (value) => DistanceUnit(value,inf?.attributes?.distanceUnit || "km"),
    },
    {
      title: trans("Odometer End"),
      dataIndex: "endOdometer",
      sorter: true,
      width: 150,
      render: (value) => DistanceUnit(value,inf?.attributes?.distanceUnit || "km"),
    },
  ];
  const visibleColumns = useReportTableColumns(columns);

  useEffect(() => {
    if (isShown && startDate && endDate && selectedids.length > 0) {
      const from = new Date(startDate).toISOString().replace(/:/g, "%3A");
      const to = new Date(endDate).toISOString().replace(/:/g, "%3A");
      setLoading(true);
      SumTrigger(
        {
          from,
          to,
          selectedids: sumIds,
        },
        true
      );
      trigger(
        {
          from,
          to,
          selectedids,
          page: currentPage,
          pageSize: limit,
          sortBy: sort.by,
          sortOrder: sort.order,
          search: searchQuery,
          //   selectedgroups: selectedGroupIds,
        },
        true
      ).finally(() => setLoading(false));
    }
  }, [
    isShown,
    startDate,
    endDate,
    selectedids,
    currentPage,
    limit,
    trigger,
    sort.by,
    sort.order,
    searchQuery,
    // selectedGroupIds,
  ]);

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
      setSearchQuery("");
    };
  }, [SetSortFilter, setSearchQuery]);

  useEffect(() => {
    if (sumData) {
      setTotalData([
        {
          title: "Total Vehicles Tracked",
          number: sumData?.summary.deviceCount,
          type: "vehicles",
        },
        {
          title: "Highest Max Speed",
          number: sumData?.summary.highestMaxSpeed,
          type: "speed",
        },
        {
          title: "Total Distance",
          number: sumData?.summary.totalDistance,
          type: "distance",
        },
        {
          title: "Total Fuel Consumed",
          number: sumData?.summary.totalSpentFuel,
          
          type: "fuel",
        },
      ]);
    }
  }, [data, sumData]);

  useEffect(() => {
    if (data) {
      setFileName("Summary Report");
      setExportIds(selectedids);
      setStartDateE(startDate);
      setEndDateE(endDate);
    }
  }, [data, startDate, endDate, selectedids]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <AntdTable
        columns={visibleColumns}
        dataSource={data?.data || []}
        loading={loading}
        pageSize={limit}
        totalItems={data?.totalCount}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={350}
      />
    </div>
  );
};

export default DistanceSheetTable;
